import React, { useState, useEffect, useRef } from 'react';
import './BtnWhatsapp.css';
import whatsappIcon from '../../images/wpp.png';
import Modal from 'react-modal';
import baseURL from '../url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

export default function BtnWhatsapp() {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [contactos, setContactos] = useState([]);
    const [selectedContact, setSelectedContact] = useState(null);
    const [noteText, setNoteText] = useState('');
    const [visitorId, setVisitorId] = useState('');
    const [messages, setMessages] = useState([]);
    const chatContainerRef = useRef(null);

    const generateUUID = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };

    useEffect(() => {
        cargarContacto();
        const id = localStorage.getItem('telegram_visitor_id');
        if (id) {
            setVisitorId(id);
        } else {
            const newId = generateUUID();
            localStorage.setItem('telegram_visitor_id', newId);
            setVisitorId(newId);
        }
    }, []);

    useEffect(() => {
        if (modalIsOpen && visitorId) {
            const loadMessages = () => {
                fetch(`https://cogelobarato.com/telegram/obtener_mensajes.php?visitor_id=${visitorId}`)
                    .then(res => res.json())
                    .then(data => {
                        if (Array.isArray(data)) {
                            setMessages(data);
                        }
                    })
                    .catch(err => console.error('Error al cargar mensajes:', err));
            };
            loadMessages();
            const interval = setInterval(loadMessages, 3000);
            return () => clearInterval(interval);
        }
    }, [modalIsOpen, visitorId]);

    // 👇 Desplazar al final del chat cada vez que cambian los mensajes
    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    }, [messages]);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto.reverse() || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const openModal = () => setModalIsOpen(true);
    const closeModal = () => setModalIsOpen(false);

    const handleTelegramMessage = () => {
        if (!visitorId || !noteText.trim()) return;

        fetch('https://cogelobarato.com/telegram/enviar_mensaje_web.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                visitor_id: visitorId,
                message: noteText
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setNoteText('');
                }
            })
            .catch(error => console.error('Error al enviar a Telegram:', error));
    };

    return (
        <div className='containWpp'>
            <button className='btnWhatsapp' onClick={openModal}>
                <img src={whatsappIcon} alt="whatsappIcon" />
            </button>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                className="modal-wpp"
                overlayClassName="overlay-wpp"
                ariaHideApp={false}
            >
                <div className='containModalWpp'>
                    <div className='headerWpp'>
                        {contactos.length > 1 ? (
                            <span>Selecciona un teléfono</span>
                        ) : (
                            <span>Atención al cliente</span>
                        )}
                        <button onClick={closeModal} className='closeBtn'>X</button>
                    </div>

                    {/* Mensaje de bienvenida solo si no hay mensajes */}
                    {messages.length === 0 && (
                        <div className='mensaje-bienvenida'>
                            <p>Hola 👋 ¿en qué podemos ayudarte?</p>
                        </div>
                    )}

                    {/* Área de chat con scroll */}
                    <div className='chat-scroll-area' ref={chatContainerRef}>
                        {messages.map((msg, i) => (
                            <div
                                key={i}
                                className={`mensaje-bubble ${msg.type === 'sent' ? 'sent' : 'received'}`}
                            >
                                {msg.text}
                            </div>
                        ))}
                    </div>

                    <div className='btnsWpp'>
                        {contactos.length > 1 && (
                            <div className='btnsWpp-inner'>
                                {contactos.map(item => (
                                    <button
                                        key={item.idContacto}
                                        className='btnWpp'
                                        style={{ backgroundColor: selectedContact?.idContacto === item.idContacto ? 'green' : '' }}
                                        onClick={() => setSelectedContact(item)}
                                    >
                                        {item.telefono}
                                        <img src={whatsappIcon} alt="whatsappIcon" />
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className='sendWpp'>
                        <textarea
                            placeholder="Escribe tu mensaje..."
                            value={noteText}
                            onChange={(e) => setNoteText(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    handleTelegramMessage();
                                }
                            }}
                        />
                        <button onClick={handleTelegramMessage}>
                            <FontAwesomeIcon icon={faPaperPlane} />
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}